import qs from 'query-string';
import { get } from './baseApi';

export const JobApi = {
    fetch: (query, options) => get(`/jobs?${qs.stringify(query)}`, options),
};
